export default __webpack_public_path__ + "static/media/Contact_Icon-02.1907127f.png";